import { Color } from '@billy/design-system'
import styled from '@emotion/styled'

const DOT_SIZE = 8
const RING_BORDER_WIDTH = 1.5

interface QuoteInvoicedStatusDotWrapperProps {
  isRing: boolean
}

export const QuoteInvoicedStatusDotWrapper = styled.span<QuoteInvoicedStatusDotWrapperProps>`
  display: inline-block;
  box-sizing: border-box;
  width: ${DOT_SIZE}px;
  height: ${DOT_SIZE}px;
  border: ${({ isRing }) => (isRing ? `${RING_BORDER_WIDTH}px solid ${Color.Lavender600}` : 'none')};
  border-radius: 50%;
  background: ${({ isRing }) => (isRing ? 'transparent' : Color.Lavender600)};
`
